<template>
    <div>
        <vs-popup title="Criar Conexão" 
            :button-close-hidden="false" 
            :active.sync="isActive"
            @close="close()"
            id="create-instance-popup"
        > 
            <div class="create-instance-modal">
                <div class="create-instance-modal__header">
                    <h5 class="create-instance-modal__tenant">A conexão será criada para a Dash "{{ tenantName }}"</h5>
                    <p class="create-instance-modal__subtitle">Defina o nome da conexão e marque apenas as opções necessárias.</p>
                </div>

                <vs-input label="Nome da Conexão" v-model="instanceName" class="mt-5 w-full" name="tenantName"/>
                <span class="text-danger text-sm" v-show="errors.has('tenantName')">
                    {{ errors.first('tenantName') }}
                </span>

                <div class="create-instance-modal__options">
                    <div class="create-instance-option">
                        <vs-checkbox v-model="isOfficial" size="small">
                            <span class="create-instance-option__title">Conexão Oficial</span>
                        </vs-checkbox>
                        <p class="create-instance-option__description">
                            Cria a Conexão na Integração Cloud com um dos fornecedores oficiais.
                        </p>

                        <div v-if="isOfficial" class="create-instance-option__provider">
                            <span class="create-instance-option__provider-label">Fornecedor Oficial</span>

                            <div class="create-instance-option__provider-options">
                                <vs-radio
                                    v-for="provider in officialInstanceProviders"
                                    :key="provider.value"
                                    v-model="officialProvider"
                                    :vs-value="provider.value"
                                    vs-name="createOfficialProvider"
                                >
                                    {{ provider.label }}
                                </vs-radio>
                            </div>
                        </div>
                    </div>

                    <div class="create-instance-option">
                        <vs-checkbox v-model="isUnlimited" size="small">
                            <span class="create-instance-option__title">Conexão Ilimitada</span>
                        </vs-checkbox>
                        <p class="create-instance-option__description">
                            Usa o tipo de conexão ilimitada no Faturamento Mensal.
                        </p>
                    </div>

                    <div v-if="!isOfficial" :class="['create-instance-option', 'create-instance-option--sync', { 'create-instance-option--active': useSync }]">
                        <vs-checkbox v-model="useSync" size="small">
                            <span class="create-instance-option__title">Conexão de Ativação Cloud</span>
                        </vs-checkbox>
                        <p class="create-instance-option__description">
                            Ativa temporariamente a versão para apoio em Ativações Cloud.
                        </p>

                        <div class="create-instance-option__warning" v-if="useSync">
                            <div class="con-vs-alert no-message-alert con-vs-alert-warning">
                                <div class="vs-alert">
                                    <p><b>Atenção:</b> use esta opção somente para Ativações Cloud.</p>
                                    <p class="mt-2">Qualquer conexão que permanecer nessa versão será trocada automaticamente.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="create-instance-modal__actions">
                    <span>
                        <vs-button color="danger" type="border" @click="close()">
                            <span> Cancelar </span>
                        </vs-button>
                    </span>

                    <span>
                        <vs-button class="ml-3" size="medium" @click="createInstance()">
                            <span> Criar </span>
                        </vs-button>
                    </span>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
    import instanceHttp from './../../http/requests/connections/index';
    import { mapGetters } from 'vuex';
    import {
        DEFAULT_OFFICIAL_INSTANCE_PROVIDER,
        officialInstanceProviders
    } from './../../supports/officialInstanceProviders';

    export default {
        data() {
            return {
                instanceName: '',
                isOfficial: false,
                isUnlimited: false,
                useSync: false,
                officialProvider: DEFAULT_OFFICIAL_INSTANCE_PROVIDER,
                officialInstanceProviders
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
            tenantName: {
                type: String,
                required: true
            }
        },
        emits: [
            'isActiveFalse',
            'successfullyCreated'
        ],
        methods: {
            closePopUpCreate(){
                this.$emit('isActiveFalse');
            },
            verify(){
                const permissions = localStorage.getItem('permissions');
                const twoFactor = localStorage.getItem('twoFactor')
                if(!permissions && !twoFactor){
                    this.$router.push('/user-settings')
                }else if(!permissions && twoFactor){
                    this.$router.push('/two-factor')
                }
            },
            createInstance() {
                if (this.instanceName.trim() === '' || this.instanceName === null) {
                    return this.$vs.notify({
                        title: 'Insira o nome para prosseguir com a criação!',
                        color: 'danger'
                    });
                }

                instanceHttp.createInstance(
                    this.instanceName,
                    this.tenantName,
                    this.isOfficial,
                    this.isUnlimited,
                    this.useSync,
                    this.officialProvider,
                    this.token
                )
                .then(response => {
                    this.$vs.notify({
                        title: 'Sucesso!',
                        text: 'Conexão criada com sucesso!',
                        color: 'success'
                    });
                    return this.$emit('successfullyCreated', response);
                })
                .catch(Exception => {
                    console.log(Exception);
                    return this.$vs.notify({
                        title: 'Erro!',
                        text: 'Algo deu errado ao tentar criar a conexão!',
                        color: 'danger'
                    });
                });
            },
            close() {
                this.isOfficial  = false;
                this.isUnlimited = false;
                this.useSync = false;
                this.officialProvider = DEFAULT_OFFICIAL_INSTANCE_PROVIDER;
                this.$emit('isActiveFalse');
            }
        },
        watch: {
            isActive() {
                this.instanceName = '';
                this.isOfficial  = false;
                this.isUnlimited = false;
                this.useSync = false;
                this.officialProvider = DEFAULT_OFFICIAL_INSTANCE_PROVIDER;
            },
            isOfficial(value) {
                if (value) {
                    this.useSync = false;
                    return;
                }

                this.officialProvider = DEFAULT_OFFICIAL_INSTANCE_PROVIDER;
            }
        },
        computed: {
            ...mapGetters([
                'token'
            ])
        },
        mounted(){
            this.verify()
        },
        created(){
            this.$events.on('closePopUpCreate', this.closePopUpCreate);
        },
        beforeDestroy() {
            this.$events.off('closePopUpCreate', this.closePopUpCreate);
        }
    }
</script>

<style lang="scss">
#create-instance-popup {
    div.vs-popup {
        .vs-popup--content {
            padding: 18px;
            margin: 0;
        }
        margin: 0;
        border-color: rgba(18, 17, 17, 0.769);
        width: 560px !important;

        .create-instance-modal__header {
            margin-bottom: 4px;
        }

        .create-instance-modal__tenant {
            color: #4b4b4b;
            margin-bottom: 6px;
        }

        .create-instance-modal__subtitle {
            color: #7a7a7a;
            font-size: 0.92rem;
            line-height: 1.4;
            margin: 0;
        }

        .create-instance-modal__options {
            display: flex;
            flex-direction: column;
            gap: 12px;
            margin-top: 18px;
        }

        .create-instance-option {
            border: 1px solid #e7e7e7;
            border-radius: 10px;
            padding: 14px 14px 12px;
            background: #fafafa;
        }

        .create-instance-option--sync {
            border-color: #ffe1a8;
            background: #fffaf0;
        }

        .create-instance-option--active {
            border-color: #ffb74d;
            background: #fff6e5;
        }

        .create-instance-option__title {
            color: #2f2f2f;
            font-weight: 600;
        }

        .create-instance-option__description {
            color: #6c6c6c;
            font-size: 0.88rem;
            line-height: 1.45;
            margin: 8px 0 0 28px;
        }

        .create-instance-option__warning {
            margin-top: 12px;
        }

        .create-instance-option__provider {
            margin: 12px 0 0 28px;
            padding-top: 12px;
            border-top: 1px solid #ececec;
        }

        .create-instance-option__provider-label {
            display: block;
            color: #4b4b4b;
            font-size: 0.82rem;
            font-weight: 600;
            margin-bottom: 10px;
            text-transform: uppercase;
            letter-spacing: 0.03em;
        }

        .create-instance-option__provider-options {
            display: flex;
            flex-wrap: wrap;
            gap: 14px;
        }

        .create-instance-modal__actions {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-top: 18px;
        }
    }
}
</style>